<div class="forceDefaultColors page">
  <div class="header">
    <div class="header-logo">
      <img [src]="selectedPdfLogoImageUrl || pdfLogo || whitelabelService.logo" alt="" />
      <div class="header-text-blured">
        <div class="header-text-blured-row">
          <div class="header-text-line header-text-line--label-1"></div>
          <div class="header-text-line header-text-line--value-1"></div>
        </div>
        <div class="header-text-blured-row">
          <div class="header-text-line header-text-line--label-2"></div>
          <div class="header-text-line header-text-line--value-2"></div>
        </div>
        <div class="header-text-blured-row">
          <div class="header-text-line header-text-line--label-3"></div>
          <div class="header-text-line header-text-line--value-3"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="middle">
    <div class="middle-title">
      <p>{{ 'whitelabel.auditPage' | translate }}</p>
    </div>
    <div class="middle-content">
      <div class="middle-content-qrcode">
        <img class="middle-content-qrcode-image" src="assets/qrcode.png" alt="QR code" />
        <div class="middle-content-qrcode-hash">
          <i class="fa-solid fa-key"></i>
          <div class="middle-content-qrcode-hash-blured">
            <div class="middle-content-qrcode-hash-line middle-content-qrcode-hash-line--value-1"></div>
            <div class="middle-content-qrcode-hash-line middle-content-qrcode-hash-line--value-2"></div>
            <div class="middle-content-qrcode-hash-line middle-content-qrcode-hash-line--value-3"></div>
          </div>
        </div>
      </div>
      <div class="middle-content-section">
        <div class="middle-content-section-link">
          <i class="fa-solid fa-link"></i>
          <div class="middle-content-section-link-blured">
            <div class="middle-content-section-line middle-content-section-line--short"></div>
            <div class="middle-content-section-line middle-content-section-line--url"></div>
          </div>
        </div>
        <div class="middle-content-section-text">
          <div class="middle-content-section-text-row">
            <i class="fa-solid fa-signature"></i>
            <div class="middle-content-section-line middle-content-section-line--medium"></div>
          </div>
          <div class="middle-content-section-text-row">
            <i class="fa-solid fa-balance-scale"></i>
            <div class="middle-content-section-line middle-content-section-line--long"></div>
          </div>
        </div>
        <div class="middle-content-section-warning">
          <i class="fa-solid fa-info-circle"></i>
          <div class="middle-content-section-warning-blured">
            <div class="middle-content-section-line middle-content-section-line--title"></div>
            <div class="middle-content-section-line middle-content-section-line--warning-1"></div>
            <div class="middle-content-section-line middle-content-section-line--warning-2"></div>
            <div class="middle-content-section-line middle-content-section-line--warning-3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="signatures">
    <div class="signatures-title">
      <p>{{ 'whitelabel.signaturesInDocument' | translate }}</p>
    </div>
    <div class="signatures-section">
      <div class="signatures-section-signer">
        <app-blured-signer [selectedPdfLogoMiniImageUrl]="selectedPdfLogoMiniImageUrl || pdfLogoMini || whitelabelService.pdfLogoMini"></app-blured-signer>
      </div>
      <div class="signatures-section-signer">
        <app-blured-signer [selectedPdfLogoMiniImageUrl]="selectedPdfLogoMiniImageUrl || pdfLogoMini || whitelabelService.pdfLogoMini"></app-blured-signer>
      </div>
    </div>
  </div>
  <div class="historico">
    <div class="historico-title">
      <p>{{ 'whitelabel.history' | translate }}</p>
    </div>
    <div class="historico-events">
      <app-blured-event></app-blured-event>
      <app-blured-event></app-blured-event>
      <app-blured-event></app-blured-event>
      <app-blured-event></app-blured-event>
      <app-blured-event></app-blured-event>
      <app-blured-event></app-blured-event>
    </div>
  </div>
</div>
